import type { CriterionInUseError } from '../../../services/api';

/** Type-Guard für den 409-Body „Auswertung wird in Hooks verwendet“ (CA-663). */
export function isCriterionInUseError(error: unknown): error is CriterionInUseError {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { code?: unknown }).code === 'EVALUATION_CRITERION_IN_USE' &&
    Array.isArray((error as { details?: { usages?: unknown } }).details?.usages)
  );
}
